define(function (require) {
	var $ = require("jquery");
	require("bootstrap");
	var _Drop = require("drop");
	var ajax = require("ajax-promise");
	var typeahead = require("typeahead");
	var errorHandler = require("error-handler");
	var QuantaFormValidator = require("quanta-form-validator");

	$(document).ready(function () {

		//On calcul la position des sous menu du header au chargement de la page
		SetOffsetSubMenu();

		//Sous menu
		$("#position-menu-quantalys a[data-toggle='collapse']").click(function (e) {

			var aHref = $(this).attr('data-target');
			if (aHref != undefined) {
				//On récupère l'ID du target pour ouvrir le sous menu
				var targetId = aHref.substring(1, aHref.length);
				if (targetId != undefined) {
					//Si le menu est fermé, on l'ouvre et on ferme tout les autres
					if (!$("#" + targetId).hasClass("in")) {
						$("#position-menu-quantalys nav.navbar .collapse.in").collapse('hide');
						$("#" + targetId).collapse('show');
					}
				}
			}
		});

		$('.menu-quantalys').find('li a').on('click', function () {
			clickMenuManager($('.menu-quantalys'), $(this));
		});

		$('a:not(.menu-quantalys li a)').on('click', function () {
			resetActiveMenu($('.menu-quantalys'), this);
		});

		//Initialisation de la Popover du menu connexion
		InitFormulaireConnexion();
		InitPopoverConnexion();
		InitPopoverAccount();
		InitQuickSearch();
		clickMenuManager($('.menu-quantalys'));
	});

	//#region Position du sous menu
	function SetOffsetSubMenu() {
		$("#position-menu-quantalys a[data-toggle='collapse']").each(function (i) {
			var aHref = $(this).attr('data-target');
			if (aHref != undefined) {
				//On récupère l'ID du target pour ouvrir le sous menu
				var targetId = aHref.substring(1, aHref.length);
				if (targetId != undefined) {
					var subMenuWidth = WidthDisplay($("#" + targetId + " .submenu-li"), $("#" + targetId));
					var posXParent = $(this).offset().left;
					var widthParent = $(this).width();
					var positionMenuQuantalys = $("#position-menu-quantalys").position().left;
					var menuQuantalysWidth = $("#" + targetId).width();
					var positionMenuActu = $(this).offset().left;

					var marginLeftAjustementPositionSousMenu = positionMenuQuantalys - positionMenuActu;



					//On repositionne notre sous menu qui est en position absolue pour qu'il soit au bord gauche du header
					$("#" + targetId).css("margin-left", marginLeftAjustementPositionSousMenu + "px");

					var offsetMenu = GetOffsetSubmenu(posXParent, widthParent, subMenuWidth, positionMenuQuantalys, positionMenuQuantalys + menuQuantalysWidth);

					/*if (menuQuantalysWidth == 750 && targetId == "collapseOutils") {
						offsetMenu -= 49;
					}*/


					$("#" + targetId + " .submenu-offset").css("margin-left", offsetMenu + "px");
					//$("#" + targetId + " .submenu-offset").css("margin-left", "32%");

				}
			}
		});
	}

	function GetOffsetSubmenu(posXParent, widthParent, widthSubmenu, posXMinimum, posXMaximum) {
		var offsetLeft = posXParent + widthParent / 2 - posXMinimum - widthSubmenu / 2;
		var marginDiv = 10;
		var containerWidth = posXMaximum - posXMinimum;

		//Cas extrême coté gauche
		if (offsetLeft < 0) {
			return marginDiv;
		}

		//Cas extrême coté droit
		if (offsetLeft + widthSubmenu > containerWidth) {
			return containerWidth - widthSubmenu - marginDiv;
		}
		return offsetLeft;
	}

	function GetSubmenuAssociate(idListe) {
		var aHref = $("#" + idListe).attr('data-target');
		if (typeof aHref !== "undefined" && aHref !== null) {
			//On récupère l'ID du target pour ouvrir le sous menu
			var targetId = aHref.substring(1, aHref.length);
			if (targetId != undefined) {
				return targetId;
			}
		}
		return undefined;
	}

	function SubMenuState(targetId) {
		var container = $("#" + targetId)
		container.mousemove(function (event) {
			var relativePositionX = (event.PageX - this.offsetLeft);
			var relativePositionY = (event.PageY - this.offsetTop);
		});
		container.mouseout(function () {
			container.collapse('hide');
		})
	}

	function WidthDisplay(enfant, parent) {
		var position = parent.css("position");
		var visibility = parent.css("visibility");
		var display = parent.css("display");

		var style = parent.attr("style");

		parent.css({ "position": "absolute", "visibility": "hidden", "display": "block" });
		var width = enfant.width();
		parent.removeAttr("style");
		parent.attr("style", style);
		//parent.css({ "position": position, "visibility": visibility, "display": display });
		return width;
	}
	//#endregion

	//#region Connection
	function InitPopoverConnexion() {
		if ($("#btnConnexion").length === 0) return;

		var drop = new _Drop({
			target: $(".btn-connexion").get(0),
			classes: 'drop-theme-arrows-bounce',
			position: 'bottom right',
			constrainToWindow: true,
			constrainToScrollParent: false,
			//attachment: 'top right',
			//targetAttachment: 'bottom right',
			openOn: 'click',
			content: $("#contentConnexion").get(0)
		});

		return drop;
	}
	function InitPopoverAccount() {
		if ($("#btnAccount").length === 0) return;

		var drop = new _Drop({
			target: $(".btn-account").get(0),
			classes: 'drop-theme-arrows-bounce',
			position: 'bottom right',
			constrainToWindow: true,
			constrainToScrollParent: false,
			//attachment: 'top right',
			//targetAttachment: 'bottom right',
			openOn: 'click',
			content: $("#contentAccount").get(0)
		});

		return drop;
	}
	function InitFormulaireConnexion() {
		var $connexionFields = $("#contentConnexion").find(".validation-connexion-header");
		$connexionFields.QuantaFormValidator({
			feedBackDisplay: {
				isDisplayIconError: false
			}
		});

		$("#btnConnecter").click(function (e) {
			if ($connexionFields.QuantaFormValidator("IsValid")) {
				var identifiant = $("#inputLogin").val();
				var password = $("#inputPassword").val();
				var remember = $("#inputRemember").is(':checked');

				ajax.post("/Login/CheckLogin", {
					identifiant: identifiant,
					password: password,
					remember: remember,
					bLoginWebClient: false
                }).then(function (response) {
                    if (response.sReturnURL != null && response.sReturnURL != "")
						window.location.href = response.sReturnURL;
					else
						window.location.reload(false);
                }).catch(function (ex) {
                    errorHandler.displayError(ex);
                });
            }
			e.preventDefault();

		});
	}
	//#endregion

	//#region Recherche rapide
	function InitQuickSearch() {
		InitTypeAheadQuickSearch();
		InitFocusSearch();
	}

	function InitTypeAheadQuickSearch() {
		var maxItemDisplayed = 6;

		$("#inputSearch").typeahead({
			order: "desc",
			hint: false,
			cancelButton: false,
			dynamic: true,
			source: {
				ajax: {
					url: '/Recherche/Produits',
					data: {
						sSearch: "{{query}}",
						maxItem: maxItemDisplayed
					}
				}
			},
			display: ["sCodeISIN", "sNom"],
			cache: false,
			compression: true,
			generateOnLoad: false,
			template: "<div class='typeahead-search-nom'>{{sNom}}</div><div  class='typeahead-search-code-isin'>{{sCodeISIN}}</div>",
			minLength: 2,
			maxItem: maxItemDisplayed,
			accent: true,
			ttl: 43200000,// = 12h (en ms)
			callback: {
				onClickAfter: function (node, a, item, event) {
					window.location = "/Produit/" + item.ID_Produit;
					//ajaxData.ID_Produit = item.ID_Produit;

					//ReloadDataTable(true).then(function () {
					//    ajaxData.ID_Produit = null;
					//});
				}
			}
		});
	}

	function InitFocusSearch() {
		$("#inputSearch").on("focusin", function () {
			$(".search-menu-float").find(".typeahead__button").focus();
		});

		$("#inputSearch").on("focusout", function () {
			$(".search-menu-float").find(".typeahead__button").trigger("focusout");
		});
	}
	//#endregion

	//-------------------------------------------------------------------------------------
	//---------------------[ affichage de l'élément cliqué ]-------------------------------
	//-------------------------------------------------------------------------------------
	function setMenuActive() {
		if (localStorageCheck()) {
			$root = $('.menu-quantalys');

			var menuClickManager = JSON.parse(localStorage.getItem('data-active-menu'));
			if (menuClickManager && (menuClickManager.menuParentId || menuClickManager.subMenuId)) {

				// active l'enfant de l'élément du menu
				if (menuClickManager.menuParentId != null && menuClickManager.subMenuId > -1) {
					var liParent = $root.find('.navbar').find('.navbar-nav > li').get(menuClickManager.menuParentId);
					$($(liParent).find('.submenu-li > li').get(menuClickManager.subMenuId)).find('> a').addClass('active');
				}

				// active l'élement sans enfants
				else if (menuClickManager.subMenuId > -1) {
					$($root.find('.navbar').find('.navbar-nav > li').get(menuClickManager.subMenuId)).find('> a').addClass('active');
				}
			}
		}
	}


	//-------------------------------------------------------------------------------------
	//-----------------------[ sauvegarde l'élément cliqué ]-------------------------------
	//-------------------------------------------------------------------------------------
	function clickMenuManager($root, elt) {
		if (localStorageCheck()) {
			$root.find('a.active').removeClass('active');
			if (!elt)
				elt = null
			$root.find('a.active').removeClass('active');

			if (elt && elt.length > 0) {
				var parent = $(elt).parents('.submenu-li').parents('li');
				var menuParent = $(parent).find('> a');

				var info = {
					menuParentId: null,
					subMenuId: null
				};

				//--[ clique d'un élément du menu sans enfant ]
				if (parent.length == 0) {
					info.subMenuId = $.inArray($(elt).parent('li').get(0), $(elt).parents('.navbar').find('.navbar-nav > li'));
				}

				//--[ clique sur un enfant d'un élément du menu ]
				else {
					info.menuParentId = $.inArray($(parent).get(0), $(elt).parents('.navbar').find('.navbar-nav > li'));
					info.subMenuId = $.inArray($(elt).parent('li').get(0), $(menuParent).next('.submenu-position').find('.submenu-li > li'));
				}

				if (($(parent).length == 0 && $(elt).next('.submenu-position').length == 0) || (info.menuParentId != null & info.subMenuId != null)) {
					localStorage.setItem('data-active-menu', JSON.stringify(info));
				}
			}

			setMenuActive();
		}
	}

	function resetActiveMenu($root, elt) {
		if (localStorageCheck()) {
			$root.find('a.active').removeClass('active');
			if (!$(elt).data('menu-link'))
				localStorage.setItem('data-active-menu', JSON.stringify([]));
		}
	}

	//-------------------------------------------------------------------------------------
	//------------------------------[ local storage check ]--------------------------------
	//-------------------------------------------------------------------------------------
	function localStorageCheck() {
		var test = 'test';
		try {
			localStorage.setItem(test, test);
			localStorage.removeItem(test);
			return true;
		} catch (e) {
			return false;
		}
	}
});
